import React from "react";
import { PageHeader } from "./PageHeader";

export const ProgramKD = props => {
  return (
    <React.Fragment>
      <PageHeader title="Konferencja dydaktyczna" />
      <div className="content-wrapper">
        <div className="main-content kkd" >
            <div className="book-info">
                W dniach 14 i 15 września w ramach Zjazdu odbędzie się Konferencja Dydaktyczna. Rejestracja na miejscu na konferencję odbywa się wspólnie z rejestracją pozostałych uczestników Zjazdu, w godzinach jak powyżej (nie będzie rejestracji w budynku WFAIS w sobotę).
                Konferencja Dydaktyczna rozpoczyna się w Auditorium Maximum wraz z początkiem sobotniej sesji plenarnej wykładami oraz debatą „Granice Fizyki” (wspólnie z pozostałymi uczestnikami Zjazdu). Po obiedzie uczestnicy Konferencji Dydaktycznej zostaną przewiezieni do budynku WFAIS (odjazd autobusów o godz. 14:30 spod budynku Auditorium Maximum), gdzie odbędą się wykłady, warsztaty i „Bazar dobrych praktyk”. Uczestnicy biorą udział w jednych z pięciu proponowanych warsztatów, wybór warsztatów będzie odbywał się podczas rejestracji. Po zakończeniu warsztatów uczestnicy samodzielnie wracają do centrum Krakowa.
                W niedzielę Konferencja Dydaktyczna rozpoczyna się w Auditorium Maximum o godzinie 9:00 wykładami plenarnymi, po czym po przerwie kawowej odbędę się osobne wykłady dla uczestników Konferencji Dydaktycznej w Auli Średniej (B/C) Auditorium Maximum. Po przerwie obiadowej odbędzie się sesja plakatowa wspólna z pozostałymi uczestnikami Zjazdu. Od godziny 17:00 odbędą się wydarzenia otwarte (wykłady i pokaz eksperymentów fizycznych), a Konferencja zakończy się widowiskiem multimedialnym, zaczynającym się o godz. 20:00.
                Niezależnie od uczestnictwa w Konferencji Dydaktycznej zapraszamy jej uczestników na pozostałe wykłady Zjazdu.

            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <br/>
                <h4 className="h4">Sobota, 14 września 2019 r. (Wydział Fizyki, Astronomii i Informatyki Stosowanej, Uniwersytet Jagielloński)</h4>
                <table className="table table-striped konfd">
                    <thead>
                    <tr>
                        <th>Godzina</th>
                        <th>Tytuł</th>
                        <th>Wykładowca</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="alert-primary">
                        <td>13:30 - 14:30</td>
                        <td className="text-center">Przerwa obiadowa</td>
                        <td></td>
                    </tr>
                    <tr className="alert-warning">
                        <td>14:30 - 15:00</td>
                        <td className="text-center">Przejazd autobusem na WFAIS (odjazd spod budunku Auditorium Maximum) </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>15:00 - 15:30</td>
                        <td>Problemy z nauczaniem przedmiotów ścisłych w szkole o pozornych wymaganiach</td>
                        <td>Jerzy Lackowski</td>
                    </tr>
                    <tr>
                        <td>15:30 - 16:00</td>
                        <td>Fizyka w gwiezdnych wojnach, czyli fikcja i fantastyka oczami fizyka</td>
                        <td>Witold Zawadzki</td>
                    </tr>
                    <tr>
                        <td>16:00 - 16:40</td>
                        <td>Metoda elementarna w Rekomendacji PTF – szacowanie niepewności pomiaru wielkości mierzonych pośrednio</td>
                        <td>Włodzimierz Natorf<br/>Andrzej Majhofer<br/>Tadeusz Molenda</td>
                    </tr>
                    <tr>
                        <td>16:40 - 17:00</td>
                        <td>Wybrane stanowiska dydaktyczne inspiracją do popularyzacji optoelektroniki</td>
                        <td>Kaziemierz Gut</td>
                    </tr>
                    <tr className="alert-primary">
                        <td>17:00 - 17:30</td>
                        <td className="text-center">Przerwa kawowa</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>17:30 - 18:30</td>
                        <td>Bazar dobrych praktyk</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>18:30 - 19:30</td>
                        <td>Warsztaty dla nauczycieli (równoległe):<br/>
                            1. "Wykorzystanie symulacji komputerowych w nauczaniu fizyki"<br/>
                            2. "Tracker - narzędzie do analizy filmów"<br/>
                            3. "Sprawdzian z fizyki Quizizz"<br/>
                            4. "Kosmos w klasie… – jak warto wprowadzać zjawiska astronomiczne na fizyce?"<br/>
                            5. "Spektroskop, czyli jak zobaczyć widma"
                        </td>
                        <td> <br/>Dagmara Sokołowska<br/>Witold Zawadzki<br/>Tomasz Greczyło<br/>Małgorzata Szymura<br/>Krzysztof Grochot</td>
                    </tr>
                    </tbody>
                </table>
                    <h4 className="h4">Niedziela, 15 września 2019 r. (Aditorium Maximum, Uniwersyetet Jagielloński)</h4>
                    <table className="table table-striped konfd">
                        <thead>
                        <tr>
                            <th>Godzina</th>
                            <th>Tytuł</th>
                            <th>Wykładowca</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>11:30 - 12:00</td>
                            <td>Uwagi nestorki, od 50.lat bacznej obserwatorki systemów nauczania i dydaktyki fizyki. Przyszłość szkoły i nauczania</td>
                            <td>Zofia Gołąb-Meyer</td>
                        </tr>
                        <tr>
                            <td>12:00 - 12:30</td>
                            <td>Wybrane zjawiska optyczne: dyspersja i polaryzacja chromatyczna</td>
                            <td>Ewa Dębowska</td>
                        </tr>
                        <tr>
                            <td>12:30 - 12:50</td>
                            <td>Science on Stage – interdyscyplinarność i podniesienie jakości edukacji</td>
                            <td>Grzegorz Musiał</td>
                        </tr>
                        <tr>
                            <td>12:50 - 13:10</td>
                            <td>Turniej Młodych Fizyków i jego znaczenie edukacyjne</td>
                            <td>Andrzej Nadolny</td>
                        </tr>
                        <tr>
                            <td>13:10 - 13:30</td>
                            <td>Dynamika chodzenia</td>
                            <td>Grzegorz Wojewoda</td>
                        </tr>
                        <tr className="alert-primary">
                            <td>13:30 - 15:00</td>
                            <td className="text-center">Przerwa obiadowa</td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ProgramKD.propTypes = {};
